"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONDC_FULLFILMENT_TYPE = exports.FULFILLMENT_TYPE = void 0;
var FULFILLMENT_TYPE;
(function (FULFILLMENT_TYPE) {
    FULFILLMENT_TYPE["DOORSTEP_DELIVERY"] = "DOORSTEP_DELIVERY";
    FULFILLMENT_TYPE["PICKUP_FROM_STORE"] = "PICKUP_FROM_STORE";
    FULFILLMENT_TYPE["BOTH"] = "BOTH";
})(FULFILLMENT_TYPE || (exports.FULFILLMENT_TYPE = FULFILLMENT_TYPE = {}));
var ONDC_FULLFILMENT_TYPE;
(function (ONDC_FULLFILMENT_TYPE) {
    ONDC_FULLFILMENT_TYPE["DELIVERY"] = "Delivery";
    ONDC_FULLFILMENT_TYPE["SELF_PICKIP"] = "Self-Pickup";
})(ONDC_FULLFILMENT_TYPE || (exports.ONDC_FULLFILMENT_TYPE = ONDC_FULLFILMENT_TYPE = {}));
